/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useContext } from "react";
import Modal from "react-modal";
import styles from "./ourProducts.module.css";

import { LanguageContext } from "../../context/LanguageContext";

function index({ products }) {
  const [open, setOpen] = useState(false);
  const [prodInfo, setProdInfo] = useState({});

  const { data } = useContext(LanguageContext);

  const Heading = data.ourProductsHeading;

  const ProductDetail = () => {
    return (
      <Modal
        bodyOpenClassName={styles.preventScroll}
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        style={{
          content: {
            padding: 0,
            position: "unset",
            margin: "100px auto",
            width: "90%",
            maxWidth: "700px",
            height: "500px",
            borderRadius: "0",
            objectFit: "cover",
            opacity: 1,
            background: "#fff",
          },
          overlay: {
            backgroundColor: "rgba(0,0,0, 0.8)",
          },
        }}
      >
        <>
          {prodInfo.moreInfo !== undefined ? (
            <div className={styles.modalStyles}>
              <button className={styles.button} onClick={() => setOpen(false)}>
                <img src={`${prodInfo.moreInfo.closeIcon}`} alt="close" />
              </button>
              <h3 className={styles.modalproductname}>{prodInfo.name}</h3>
              <div className={styles.modalWrapper}>
                <div>
                  <img
                    src={`${prodInfo.img}`}
                    alt={prodInfo.name}
                    className={styles.modalImage}
                  />
                </div>
                <div className={styles.modalContent}>
                  <p>{prodInfo.moreInfo.p1}</p>
                  <p>{prodInfo.moreInfo.p2}</p>
                </div>
              </div>
              <div className={styles.modalHeading}>
                <h3>{prodInfo.heading1} - </h3>
                <>
                  {prodInfo.varietes.map((variety, i) => (
                    <div className={styles.contentVG} key={i}>
                      <p className={styles.variety}>{`${variety}${i< prodInfo.varietes.length-1 ? ', ': ""}`}&nbsp;</p>
                    </div>
                  ))}
                </>
              </div>
              <div className={styles.modalHeading}>
                <h3>{prodInfo.heading2} - </h3>
                <>
                  {prodInfo.growers.map((grown, i) => (
                    <div className={styles.contentVG} key={i}>
                      <p className={styles.variety}>{`${grown}${i< prodInfo.growers.length-1 ? ', ': ""}`}&nbsp;</p>
                    </div>
                  ))}
                </>
              </div>

              {console.log("product info==>", prodInfo)}
            </div>
          ) : null}
        </>
      </Modal>
    );
  };

  const OnModalOpen = (productID) => {
    console.log("id", productID);
    const prodInfo = products.filter(({ id }) => id === productID);
    const info = products.find(({ id }) => id === productID);
    setProdInfo(info);
    console.log("prodInfo ===>", prodInfo);
    setOpen(true);
  };
  return (
    <>
      <div id="OurProducts" className={styles.headingWrapper}>
        <h2 className="mainHeading">{Heading[0].heading}</h2>
        <p className="subHeading">{Heading[0].subheading}</p>
      </div>
      <div className={[styles.productCards]}>
        {products?.map((item) => (
          <div className={styles.productCard} key={item.id}>
            <div className={styles.overlay}>
              <img src={`${item.img}`} alt="apples" />
              <div className={styles.btn}>
                <button onClick={() => OnModalOpen(item.id)}>
                  <p>{item.btnTitle}</p>
                </button>
              </div>
            </div>

            <p className={styles.productname}>{item.name}</p>
            {/* <div className={styles.heading}>
              <h3>{item.heading1}</h3>
              <>
                {item.varietes.map((variety, i) => (
                  <div className={styles.content} key={i}>
                    {i > 0 && ", "}
                    <p>{variety}</p>
                  </div>
                ))}
              </>
            </div>
            <div className={styles.heading}>
              <h3>{item.heading2}</h3>
              <>
                {item.growers.map((grown, i) => (
                  <div className={styles.content} key={i}>
                    <p>{grown}</p>
                  </div>
                ))}
              </>
            </div> */}
          </div>
        ))}
        {open && ProductDetail()}
      </div>
    </>
  );
}

export default index;
